import React from "react";

import { ContentModuleBaseAttributes } from "utils/orm";
import { RichTextModule } from "components/RichTextModule";
import { getTrackingPropsAsDataAttrs } from "utils/tracking";

export interface EmbedContent {
    providerName: string;
    url: string;
    height?: number;
    width?: number;
    code: string;
    type?: string;
    title?: string;
}

interface EmbedData {
    embed?: EmbedContent;
}

export interface EmbedBlock extends ContentModuleBaseAttributes {
    embed: EmbedData;
    richText?: string;
    template: string;
}

const stripWhiteSpace = (str: string) => str.replace(/\n/g, "");

const stripEnclosingDivs = (str: string) => {
    let newstr = stripWhiteSpace(str);
    [, newstr] = newstr.match(/(?:<div>)(.*)(?=<\/div>)/m);
    return newstr;
};

const getEmbedClassname = (providerName: string) => {
    const EmbedClassNameMap: { [key: string]: string } = {
        Facebook: "fb-embed-container",
        Twitter: "twitter-embed-container",
        YouTube: "ytplayer-embed-container",
        Instagram: "instagram-embed-container"
    };
    return Object.prototype.hasOwnProperty.call(EmbedClassNameMap, providerName) ? EmbedClassNameMap[providerName] : "other-embed-container";
};

const renderEmbed = (embed: EmbedContent, template: string) => {
    let oskarView;
    let oskarProps;

    if (embed.type && embed.type === "video") {
        let mediaID;
        let mediaProviderKey;

        if (embed.providerName === "YouTube") {
            mediaID = embed.url;
            mediaProviderKey = embed.url.split("=")[1];
        }

        const eventProps = {
            sp_impression_component: "insert",
            sp_impression_insert_type: "media",
            sp_impression_position: template === "article" ? "in_article" : null,
            sp_media_type: "video",
            sp_media_id: mediaID,
            sp_media_name: embed.title || null,
            sp_media_provider_key: mediaProviderKey || null,
            sp_media_provider_name: embed.providerName || null,
        };

        const trackingProps = {
            viewEvent: "videoViewed",
            eventProps
        };
        const dataProps = getTrackingPropsAsDataAttrs(trackingProps);
        ({ oskarView, oskarProps } = dataProps);
    }

    return (
        <div
            className={getEmbedClassname(embed.providerName)}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: stripEnclosingDivs(embed.code) }}
            data-video-view={oskarView}
            data-oskar-props={oskarProps}
        />
    );
};

export const EmbedModule: React.FC<EmbedBlock> = ({
    heading, embed, richText, template
}) => {
    const { embed: embedContent } = embed;

    if (!embedContent) {
        return null;
    }

    return (
        <div className="article-body__content-module__embed">
            {heading && <h1>{heading}</h1>}
            {renderEmbed(embedContent, template)}
            {richText && (
                <RichTextModule
                    className="article-body__content-module__embed__rich-text"
                    type="richTextBlock"
                    richText={richText}
                />
            )}
        </div>
    );
};
